import { LocalTime as LocalTime } from '@js-joda/core';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from './LocalDateTime.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from './Exceptions.mjs';
import {
  isJodaDateTimeParseException1w7urgwwcr7j6 as isJodaDateTimeParseException,
  isJodaDateTimeException2l3lhdyy3jadv as isJodaDateTimeException,
} from './JSJodaExceptions.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_ISO_TIME31n00f6uljtbs as get_ISO_TIME } from './format/LocalTimeFormat.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { LocalTimeIso8601Serializer_getInstance1gy7xllc2odvq as LocalTimeIso8601Serializer_getInstance } from './serializers/LocalTimeSerializers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getIsoTimeFormat() {
  return Formats_instance.n1o();
}
function atDate(_this__u8e3s4, year, monthNumber, dayOfMonth) {
  dayOfMonth = dayOfMonth === VOID ? 0 : dayOfMonth;
  return LocalDateTime().t1o(year, monthNumber, dayOfMonth, _this__u8e3s4.x1o(), _this__u8e3s4.y1o(), _this__u8e3s4.z1o(), _this__u8e3s4.a1p());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.t25_1 = LocalTime_0().f27(LocalTime.MIN);
        this.u25_1 = LocalTime_0().f27(LocalTime.MAX);
      }
      h27(input, format) {
        var tmp;
        if (format === Formats_instance.n1o()) {
          var tmp_0;
          try {
            // Inline function 'kotlinx.datetime.jsTry' call
            // Inline function 'kotlin.let' call
            var p0 = LocalTime.parse(toString(input));
            tmp_0 = LocalTime_0().f27(p0);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Error) {
              var e = $p;
              if (isJodaDateTimeParseException(e))
                throw DateTimeFormatException().y1n(e);
              throw e;
            } else {
              throw $p;
            }
          }
          tmp = tmp_0;
        } else {
          tmp = format.ev(input);
        }
        return tmp;
      }
      v25(input, format, $super) {
        format = format === VOID ? getIsoTimeFormat() : format;
        return $super === VOID ? this.h27(input, format) : $super.h27.call(this, input, format);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      n1o() {
        return get_ISO_TIME();
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  return Formats_instance;
}
var LocalTimeClass;
function LocalTime_0() {
  if (LocalTimeClass === VOID) {
    class $ {
      static f27(value) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.w1o_1 = value;
        return $this;
      }
      static z1w(hour, minute, second, nanosecond) {
        Companion_getInstance();
        second = second === VOID ? 0 : second;
        nanosecond = nanosecond === VOID ? 0 : nanosecond;
        var tmp;
        try {
          // Inline function 'kotlinx.datetime.jsTry' call
          tmp = LocalTime.of(hour, minute, second, nanosecond);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            if (isJodaDateTimeException(e))
              throw IllegalArgumentException().be(e);
            throw e;
          } else {
            throw $p;
          }
        }
        return this.f27(tmp);
      }
      x1o() {
        return this.w1o_1.hour();
      }
      y1o() {
        return this.w1o_1.minute();
      }
      z1o() {
        return this.w1o_1.second();
      }
      a1p() {
        return numberToInt(this.w1o_1.nano());
      }
      i1s() {
        return this.w1o_1.toSecondOfDay();
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof LocalTime_0()) {
            tmp_0 = this.w1o_1 === other.w1o_1 || this.w1o_1.equals(other.w1o_1);
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.w1o_1.hashCode();
      }
      toString() {
        return this.w1o_1.toString();
      }
      i27(other) {
        return this.w1o_1.compareTo(other.w1o_1);
      }
      d(other) {
        return this.i27(other instanceof LocalTime_0() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'LocalTime', VOID, VOID, [Comparable()], VOID, VOID, {0: LocalTimeIso8601Serializer_getInstance});
    LocalTimeClass = $;
  }
  return LocalTimeClass;
}
//region block: init
Formats_instance = new (Formats())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3vhybkmm49bju,
  LocalTime_0 as LocalTime22kisvxz6f9p4,
  atDate as atDatef446kt6vbj70,
};
//endregion

//# sourceMappingURL=LocalTime.mjs.map
